<style lang="scss" scoped>
.locations-row {
    display: flex;
    flex-flow: wrap;
    margin: 0 -12px;
    .location-card {
        padding: 0 12px;
        flex-grow: 1;
        flex: none;
    }
}
::v-deep .tns-ovh {
    overflow: visible;

    .tns-inner {
        @media screen and (max-width: 1279.98px) {
            overflow: scroll !important;
            margin-right: -160px !important;
            margin-left: -160px !important;
            padding-left: 160px !important;

            .tns-slider {
                > div:last-child {
                    margin-right: 144px !important;
                }
            }

            ::-webkit-scrollbar {
                display: none; /* Chrome Safari */
            }
            scrollbar-width: none; /* Firefox */
            -ms-overflow-style: none; /* IE 10+ */
        }

        @media screen and (max-width: 575.98px) {
            margin-right: -24px !important;
            margin-left: -24px !important;
            padding-left: 24px !important;


            .tns-slider {
                > div:last-child {
                    margin-right: 8px !important;
                }
            }
        }
    }
}
</style>

<template>
    <div class="container">
        <div class="row" v-if="!$root.isMobile">
            <div class="col-12">
                <div v-if="title" class="mb-40 d-flex flex-wrap w-100">
                    <h3 v-if="title" v-html="title" class="title"></h3>
                    <a v-if="generatedCtaLink" :href="generatedCtaLink" class="ml-auto my-auto link-arrow">{{ cta }} <span class="arrow-right" v-html="svg('arrow-right')" /></a>
                </div>
                <slide-y-down-transition group class="locations-row" tag="div">
                    <location-section-card v-show="show" class="location-card" :class="{ 'mb-40' : locations.length > itemsPerRow }" v-for="location in locations" :key="location.ID" :location="location" :style="{ width: `calc(100% / ${item_count})`}" :ratio="ratio" />
                </slide-y-down-transition>
            </div>
        </div>
        <div v-show="$root.isMobile" class="row">
            <div class="col-12">
                <h3 v-html="title" class="title mb-32"></h3>
                <div class="w-100" ref="sliderParent">
                    <div class="locations-slider" ref="slider">
                        <location-section-card v-show="show" class="location-card mb-40" v-for="location in locations" :key="location.ID" :location="location" :style="{ width: `calc(100% / ${item_count})`}" :ratio="ratio" />
                    </div>
                    <a v-if="generatedCtaLink" :href="generatedCtaLink" class="ml-auto my-auto link-arrow">{{ cta }} <span class="arrow-right" v-html="svg('arrow-right')" /></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import row from "../mixins/row";
import mobileSlider from "../mixins/mobile-slider";
import hasCta from "../mixins/has-cta";
import { tns } from "tiny-slider/src/tiny-slider.module"
import { SlideYDownTransition } from 'vue2-transitions'

export default {
    name: "pagePart.locations-row",

    mixins: [row, mobileSlider, hasCta],

    components: { SlideYDownTransition },

    props: {
        itemsPerRow: {
            type: Number,
            default: null,
        },
        locations: {
            type: Array,
            required: true,
            default: () => {
                return [];
            },
        },
    },

    data: (vm) => ({
        show: false,
    }),

    mounted() {
        this.show = true
    },

    computed: {
        item_count() {
            if (this.itemsPerRow) return this.itemsPerRow
            if (this.locations.length > 5) return 6;
            return this.locations.length
        },
    }
}
</script>